import React, { useState } from "react";
import Icon from "./Icon";

function Toolbar({
  viewMode,
  onViewChange,
  sortBy,
  onSortChange,
  onNewFolder,
  onUpload,
  onCreateDocument,
  onToggleActivity,
  filter,
  onFilterChange,
  searchQuery,
  onSearchChange,
  searchLoading,
  folderCount,
  fileCount,
  currentPath,
  onNavigate,
}) {
  const [showActions, setShowActions] = useState(false);

  const chips = [
    { key: "all", label: "All" },
    { key: "folders", label: "Folders" },
    { key: "documents", label: "Documents" },
  ];

  const countText = `${folderCount || 0} Folders \u00b7 ${fileCount || 0} Files`;

  // Build breadcrumb segments from path
  const buildBreadcrumb = () => {
    if (currentPath === "/") return [{ label: "All Files", path: "/" }];
    const parts = currentPath.split("/").filter(Boolean);
    const crumbs = [{ label: "All Files", path: "/" }];
    let accumulated = "";
    for (const part of parts) {
      accumulated += "/" + part;
      crumbs.push({ label: part, path: accumulated });
    }
    return crumbs;
  };

  const breadcrumbs = buildBreadcrumb();

  return (
    <div className="toolbar">
      {/* Section Label */}
      <div className="toolbar-label">CTODOCX</div>

      {/* Row 1: Breadcrumb + Action Buttons */}
      <div className="toolbar-row-1">
        <div className="toolbar-breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <span key={crumb.path} className="toolbar-crumb-item">
              {index > 0 && <span className="toolbar-crumb-sep">›</span>}
              {index < breadcrumbs.length - 1 ? (
                <button
                  className="toolbar-crumb-link"
                  onClick={() => onNavigate && onNavigate(crumb.path)}
                >
                  {index === 0 && <Icon name="folder" size={14} />}
                  {crumb.label}
                </button>
              ) : (
                <span className="toolbar-crumb-current">
                  {index === 0 && <Icon name="folder" size={14} />}
                  {crumb.label}
                </span>
              )}
            </span>
          ))}
        </div>
        <div className="toolbar-spacer"></div>
        <div className="toolbar-actions">
          <button className="toolbar-outline-btn" onClick={onNewFolder}>
            <Icon name="folderPlus" size={14} />
            <span>New Folder</span>
          </button>
          <button className="toolbar-outline-btn" onClick={onCreateDocument}>
            <Icon name="filePlus" size={14} />
            <span>Create Doc</span>
          </button>
          <button className="toolbar-outline-btn" onClick={onUpload}>
            <Icon name="upload" size={14} />
            <span>Upload</span>
          </button>
        </div>
      </div>

      {/* Row 2: Chips + Sort + View + Count + Activity + Search */}
      <div className="toolbar-row-2">
        <div className="toolbar-chips">
          {chips.map((c) => (
            <button
              key={c.key}
              className={`toolbar-chip ${(filter || "all") === c.key ? "active" : ""}`}
              onClick={() => onFilterChange && onFilterChange(c.key)}
            >
              {c.label}
            </button>
          ))}
        </div>

        <select
          className="toolbar-sort"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
        >
          <option value="name">Sort: Name</option>
          <option value="date">Sort: Modified</option>
          <option value="size">Sort: Size</option>
          <option value="type">Sort: Type</option>
        </select>

        <div className="toolbar-view-toggle">
          <button
            className={`toolbar-vbtn ${viewMode === "list" ? "active" : ""}`}
            onClick={() => onViewChange("list")}
            title="List view"
          >
            <Icon name="list" size={14} />
          </button>
          <button
            className={`toolbar-vbtn ${viewMode === "grid" ? "active" : ""}`}
            onClick={() => onViewChange("grid")}
            title="Grid view"
          >
            <Icon name="grid" size={14} />
          </button>
        </div>

        <button
          className="toolbar-activity-icon"
          onClick={onToggleActivity}
          title="Activity Log"
        >
          <Icon name="clockHistory" size={14} />
        </button>

        <span className="toolbar-count">{countText}</span>

        <div className="toolbar-search">
          <Icon name="search" size={14} />
          <input
            type="text"
            placeholder="Search documents..."
            value={searchQuery || ""}
            onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
            maxLength={200}
          />
          {searchLoading && <Icon name="spinner" size={13} className="fa-spin" />}
          {searchQuery && (
            <button
              className="toolbar-search-clear"
              onClick={() => onSearchChange && onSearchChange("")}
            >
              <Icon name="x" size={13} />
            </button>
          )}
        </div>
      </div>

      {/* Mobile FAB */}
      <div className="toolbar-fab-wrap">
        <button
          className="toolbar-fab"
          onClick={() => setShowActions(!showActions)}
          aria-label="Actions"
        >
          <Icon name={showActions ? "x" : "plus"} size={22} />
        </button>
        {showActions && (
          <>
            <div className="fab-backdrop" onClick={() => setShowActions(false)} />
            <div className="fab-menu">
              <button className="fab-item" onClick={() => { onNewFolder(); setShowActions(false); }}>
                <Icon name="folderPlus" size={18} />
                <span>New Folder</span>
              </button>
              <button className="fab-item" onClick={() => { onCreateDocument(); setShowActions(false); }}>
                <Icon name="filePlus" size={18} />
                <span>Create Doc</span>
              </button>
              <button className="fab-item" onClick={() => { onUpload(); setShowActions(false); }}>
                <Icon name="upload" size={18} />
                <span>Upload</span>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Toolbar;
